import { useCookieConsentSync } from "./useCookieConsentSync";

export function CookieConsentSync() {
  useCookieConsentSync();
  return null;
}
